var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"fill":"none","height":_vm.height,"viewBox":"0 0 8 12","width":_vm.width,"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.33333 0L0 7H4L2.66667 12L8 5H4L5.33333 0Z","fill":_vm.fill}})])
}
var staticRenderFns = []

export { render, staticRenderFns }